<!-- begin image src with "./" so it's imported as a vue 'static asset' -->
<!-- https://cli.vuejs.org/guide/html-and-static-assets.html#static-assets-handling -->
<template>
  <div class="logos">
    <a href="http://www.embo.org/funding-awards/courses-workshops/workshops" target="_blank">
      <img src="./img/emworkshop.png" alt="EMBO Workshops" title="EMBO Workshops" />
    </a>
    <a href="https://www.embo.org/" target="_blank">
      <img src="./img/embo.png" alt="EMBO" title="EMBO" />
    </a>
    <a href="https://www.embl.de/training/cco/atc/" target="_blank">
      <img src="./img/embl.png" alt="EMBL" title="EMBL" />
    </a>
  </div>
</template>

<style scoped>
.logos {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
}
img {
  height: clamp(20px, 8vw, 55px);
  width: auto;
  vertical-align: middle;
}
</style>
